import Constants from 'arts/config/constants';
import { buildWorksReducer } from 'arts/config/works_loader_actions';

const tapestries = buildWorksReducer(Constants.Tapestries);

export default tapestries;
